












import { Component, Prop, Vue } from 'vue-property-decorator'
import { StreamItem } from '@/types/stream'
import { userName } from '@/types/auth'

// TODO:
//  Make use of: `seenBy`
//  Make use of: `reactions`


@Component
export default class StreamCard extends Vue {
    @Prop() streamItem!: StreamItem

    get author(): string {
        return userName[this.streamItem.author]
    }

    get humanTimestamp() {
        const date = new Date(1970, 0, 1)
        date.setSeconds(this.streamItem.timestamp.seconds)
        const utcOffset = this.streamItem.timestamp.seconds - date.getTime() / 1000
        const newDate = new Date(1970, 0, 1)
        newDate.setSeconds(this.streamItem.timestamp.seconds + utcOffset)
        return newDate.toLocaleDateString('en-US', {
            timeZone: 'America/Chicago',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        })
    }
}
